import { parseLocalDate } from './parseLocalDate';

const localeFormats: { [key: string]: string } = {
  en_US: 'en-US',
  es_US: 'es-US',
  es_MX: 'es-MX',
  en_GB: 'en-GB',
  fr_FR: 'fr-FR',
  fr_CA: 'fr-FR',
  de_DE: 'de-DE',
};

export function formatRegionalDate(
  date: string,
  locale: `${string}_${string}` | undefined
): string {
  const parsedDate = parseLocalDate(date);
  const formatLocale = localeFormats?.[locale ?? 'en_US'] ?? 'en-US';
  return new Intl.DateTimeFormat(formatLocale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parsedDate);
}
